import { Alert, CloseButton } from '@mantine/core';
import { useEffect } from 'react';

export interface ToastProps {
  message: string;
  variant: 'success' | 'error';
  onClose: () => void;
  autoDismissMs?: number;
}

export const AppToast = ({
  message,
  variant,
  onClose,
  autoDismissMs,
}: ToastProps) => {
  useEffect(() => {
    const timeoutMs = autoDismissMs ?? (variant === 'success' ? 2000 : 4000);
    const timeoutId = window.setTimeout(onClose, timeoutMs);
    return () => window.clearTimeout(timeoutId);
  }, [autoDismissMs, onClose, variant]);

  return (
    <Alert
      color={variant === 'success' ? 'teal' : 'red'}
      styles={{
        title: { color: 'white' },
        body: { color: 'white' },
        label: { color: 'white' },
      }}
      style={{
        position: 'fixed',
        bottom: 20,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 500,
        minWidth: 280,
        maxWidth: 520,
        width: 'calc(100% - 32px)',
        backgroundColor:
          variant === 'success' ? 'rgba(0, 159, 119, 0.96)' : 'rgba(201, 42, 42, 0.92)',
        color: 'white',
      }}
      title={variant === 'success' ? 'Success' : 'Error'}
      withCloseButton={false}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
        <span>{message}</span>
        <CloseButton onClick={onClose} c="white" />
      </div>
    </Alert>
  );
};
